import {subDays} from 'date-fns';
import {Adj, Noun} from "../../../../utils/words";
import {BALANCE_STATUS} from "../../../../utils/codes";

const date = new Date();

const makeRandomNo = (num) => Math.floor(Math.random() * num);
const makeCodeNo = prefix => `${prefix}${Math.random().toString().slice(2, 11)}`
const getRandomData = list => list[makeRandomNo(list.length)];

const replyStatus = BALANCE_STATUS.map(s => s.key);

const makeSalesRow = (index) => {
  const orderPrice = makeRandomNo(100) * 1000;
  const commission = orderPrice * 0.005;
  const calcPrice = orderPrice - commission;

  return {
    id: index,
    balanceStatus: getRandomData(replyStatus),
    orderDate: subDays(date, makeRandomNo(300)),
    prodName: `${getRandomData(Adj)} ${getRandomData(Noun)}`,
    orderNo: makeCodeNo('OD'),
    orderCount: makeRandomNo(10),
    orderPrice: orderPrice,
    commission: commission,
    calcPrice: calcPrice,
  };
};

const generateData = (maker, num) => {
  const results = [];
  let index = 0;
  while (num--) results.push(maker(++index));
  return results;
};

export const salesMock10000 = () => generateData(makeSalesRow,10000);
